import {
  BUSINESS_ROUTE,
  ADVERTISEMENTS_ROUTE,
  DASHBOARD_ROUTE,
} from '@/constants';

export const categories = [
  {
    name: DASHBOARD_ROUTE,
    image: 'dashboard',
    nestedRoutes: DASHBOARD_ROUTE,
  },
  {
    name: BUSINESS_ROUTE,
    image: 'business',
    nestedRoutes: BUSINESS_ROUTE,
  },
  {
    name: ADVERTISEMENTS_ROUTE,
    image: 'advertisements',
    nestedRoutes: ADVERTISEMENTS_ROUTE,
  },
];
